angular.module("users_groups")

    .controller("usersGroupsEditCtrl", ['LoginService', '$scope', '$rootScope', '$controller', '$state', '$stateParams', 'Restangular', '$uibModal', 'modalService', '$compile', 'gridService', '$filter', '$translate', function (LoginService, $scope, $rootScope, $controller, $state, $stateParams, Restangular, $uibModal, modalService, $compile, gridService, $filter, $translate) {

        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("USERS_WRITE");
        $rootScope.title = $filter('translate')('users_groups.title');

        $scope.user_group_id = $stateParams.id;

        if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {

            $rootScope.breadcrumb = [
                { title: $filter('translate')('users_groups.title'), url: "users_groups.list" },
                { title: $filter('translate')('general.add') },
            ];
            $scope.user_group = {};
        } else {
            $rootScope.breadcrumb = [
                { title: $filter('translate')('users_groups.title'), url: "users_groups.list" },
                { title: $filter('translate')('general.edit') },
            ];

            Restangular.one('UsersGroups', $stateParams.id).get().then(function (results) {
                $scope.user_group = results;
            });
        }


        $scope.save = function (frmBudgetGroups) {

            if (!angular.isUndefined($scope.user_group.id)) {
                $scope.user_group.put().then(function (result) {
                    if (typeof (result.id) != "undefined") {
                        toastr.success($filter('translate')('users_groups.modified_success'));
                        $state.go("users_groups.list");
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            } else {
                Restangular.all('UsersGroups').post($scope.user_group).then(function (result) {
                    if (typeof (result.id) != "undefined") {
                        toastr.success($filter('translate')('users_groups.created_success'));
                        $state.go("users_groups.list");
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            }
        }

        $scope.checkDelete = function () {
            modalService.confirm({
                title: $filter('translate')('events_types.button_delete'),
                message: $filter('translate')('users_groups.delete_message') + " " + $scope.user_group.name + "?",
                onAccept: function () {
                    $scope.user_group.remove().then(function () {
                        toastr.success($filter('translate')('users_groups.remove_success'));
                        $state.go("users_groups.list");
                    });
                }
            });
        };



    }])

    ;

